
import {Component} from 'vue-property-decorator';
import TabManager from '@/mixins/TabManager';

import ItemsIndex from '@/components/ListNevronComponents/Items/IndexGeneric.vue';
import ListDevices from './ListDevices.vue';
import ListGroups from './ListGroups.vue';
import stores from "@/stores";

@Component({
  computed: {
    stores() {
      return stores
    }
  },
  components: {
    ItemsIndex,
    ListDevices,
    ListGroups,
  },
})
export default class DevicesIndex extends TabManager {

  get TAB_KEYS() {
    return ['devices', 'groups'];
  }

}
